import React, { useState, useEffect } from "react";

export default function ContentUpdateFrequency({ register, errors }) {
  const fieldName = "contentUpdateFrequency";
  const [showNewChoice, setShowNewChoice] = useState(false);

  useEffect(() => {
    register(`${fieldName}.other`); // Register the field outside the render method
  }, [register]);

  return (
    <fieldset>
      <legend className="wdc-field-label">
        How often do you think you will be updating content on the website?
      </legend>

      <div className="space-y-2.5">
        {[
          { value: "daily", label: "Daily" },
          { value: "weekly", label: "Weekly" },
          { value: "monthly", label: "Monthly" },
        ].map((item) => (
          <label
            key={item.value}
            htmlFor={`${fieldName}-${item.value}`}
            className="wdc-option"
          >
            <input
              id={`${fieldName}-${item.value}`}
              type="radio"
              className="wdc-check"
              value={item.value}
              {...register(`${fieldName}.choice`, { required: false })}
            />
            <span className="wdc-option-label">{item.label}</span>
          </label>
        ))}

        <label htmlFor={`${fieldName}-other`} className="wdc-option">
          <input
            id={`${fieldName}-other`}
            type="checkbox"
            className="wdc-check"
            value="other"
            onChange={(e) => setShowNewChoice(e.target.checked)}
          />
          <span className="wdc-option-label">Add new choice</span>
        </label>

        {errors[fieldName] && (
          <span className="wdc-error">This field is required</span>
        )}
      </div>

      {showNewChoice && (
        <div className="mt-3">
          <input
            type="text"
            placeholder="Enter new choice"
            className="wdc-field"
            {...register(`${fieldName}.otherText`)}
          />
        </div>
      )}
    </fieldset>
  );
}
